import { useState } from 'react'
import { IconSearch, IconLayoutGrid, IconList, IconUsers } from '@tabler/icons-react'
type ViewMode = 'grid' | 'list'
export function CommunityPage() {
  const [viewMode, setViewMode] = useState<ViewMode>('grid')
  const [search, setSearch] = useState('')
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-3 px-6 py-4 border-b border-border-default flex-wrap">
        <h1 className="text-sm font-medium text-zinc-200 flex-1">Community</h1>
        <div className="relative">
          <IconSearch size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-600" />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search community..."
            className="pl-7 pr-3 py-1.5 bg-surface-raised border border-border-default rounded-lg text-xs text-zinc-300 placeholder-zinc-600 outline-none focus:border-brand-orange/50 w-48" />
        </div>
        <div className="flex items-center bg-surface-raised border border-border-default rounded-lg p-0.5 gap-0.5">
          <button onClick={() => setViewMode('grid')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'grid' ? 'bg-surface-float text-zinc-200' : 'text-zinc-600 hover:text-zinc-400'}`}><IconLayoutGrid size={14} /></button>
          <button onClick={() => setViewMode('list')} className={`p-1.5 rounded-md transition-colors ${viewMode === 'list' ? 'bg-surface-float text-zinc-200' : 'text-zinc-600 hover:text-zinc-400'}`}><IconList size={14} /></button>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 rounded-2xl bg-surface-raised border border-border-default flex items-center justify-center mx-auto mb-4"><IconUsers size={24} className="text-zinc-600" /></div>
          <h3 className="text-sm font-medium text-zinc-400 mb-1">Community coming soon</h3>
          <p className="text-xs text-zinc-600 max-w-xs">Browse and discover gear bags shared by the GearLocker community.</p>
        </div>
      </div>
    </div>
  )
}
